const env = `${import.meta.env.VITE_APP_ENV}` || 'dev'
console.log(`------- 当前环境: ${JSON.stringify(import.meta.env)}`, env)

export const OssFileTypeEnum = {
  /**
   * web页面相关（运营后台、落地页）
   */
  WEB: 601
}

export const OssPathEnum = {
  /**
   * 图片路径，活动配置图片目录
   */
  PIC_ACTIVITY_UI: 'pic/activity/ui/',
  /**
   * 图片路径，活动配置预览图目录
   */
  PIC_ACTIVITY_PREVIEW: 'pic/activity/preview/',
  /**
   * 活动配置json文件目录
   */
  JSON_ACTIVITY: 'json/activity/',
  /**
   * 图片路径，用户名片
   */
  PIC_ACTIVITY_USER_CARD: 'pic/activity/user/card/'
}

const jsonActivityPath = OssPathEnum.JSON_ACTIVITY

const config = {
  baseURL: import.meta.env.VITE_BASE_URL,
  aliOssURL: import.meta.env.VITE_ALI_OSS_BASE_URL + jsonActivityPath,
  apiURL: import.meta.env.VITE_API_URL,
  baseSecret: import.meta.env.VITE_BASE_SECRET,
  aliOssApiURL: import.meta.env.VITE_ALI_OSS_API_URL,
  secretKey: import.meta.env.VITE_SECRET_KEY
}

export default config
